import "./style.css";
import { useTranslation } from "react-i18next";

export enum PasswordStatus {
  Lowercase,
  Uppercase,
  NumberOrSymbol,
  MinimumLength,
}

type Props = {
  passwordStatus: PasswordStatus[];
};

// Status display, not a form: met rules get a green check, unmet a quiet
// ring. (The old version rendered real checkboxes — wrong semantics and a
// dated teal slab.)
function PasswordRequirement(props: Props) {
  const { t } = useTranslation();

  const rules: Array<[PasswordStatus, string]> = [
    [PasswordStatus.Lowercase, t("Common.passwordRequirements.lowerCase")],
    [PasswordStatus.Uppercase, t("Common.passwordRequirements.upperCase")],
    [PasswordStatus.NumberOrSymbol, t("Common.passwordRequirements.numberOrSymbol")],
    [PasswordStatus.MinimumLength, t("Common.passwordRequirements.minLength")],
  ];

  return (
    <div className="password-requirement-component">
      <div className="password-requirement-title">
        {t("Common.passwordRequirements.title")}:
      </div>
      <ul className="password-confirm-list">
        {rules.map(([status, label]) => {
          const met = props.passwordStatus.includes(status);
          return (
            <li key={label} className={met ? "met" : undefined}>
              <span className="rule-mark" aria-hidden>
                {met ? "✓" : ""}
              </span>
              {label}
            </li>
          );
        })}
      </ul>
    </div>
  );
}

export default PasswordRequirement;
